import { CallHandler, ExecutionContext, Injectable, NestInterceptor } from '@nestjs/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ListOutputModel } from '../models';

@Injectable()
export class ResponseInterceptor implements NestInterceptor {
  public intercept(context: ExecutionContext, next: CallHandler): Observable<any> {
    return next.handle().pipe(
      map((data) => {
        if (!(data instanceof ListOutputModel)) return data;
        const response = context.switchToHttp().getResponse();
        response.header('X-Total-Count', data.count);
        return data.documents;
      })
    );
  }
}
